import React, { useEffect, useRef } from 'react'
import autoAnimate from '@formkit/auto-animate'

const ErrorMessage = ({ message }) => {
    const parent = useRef(null)
    useEffect(() => {
        parent.current && autoAnimate(parent.current)
    }, [parent])

    return (
        <div ref={parent}>
            {message && <p className="mt-2 text-red-500">{message}</p>}
        </div>
    )
}

export default ErrorMessage
